/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Birth_YearsInputs */

const en_us2_profile_editors_birth_years = /** @type {(inputs: Profile_Editors_Birth_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`years old`)
};

const pt_br2_profile_editors_birth_years = /** @type {(inputs: Profile_Editors_Birth_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anos`)
};

const es_419_profile_editors_birth_years = /** @type {(inputs: Profile_Editors_Birth_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`años`)
};

const pt_pt2_profile_editors_birth_years = /** @type {(inputs: Profile_Editors_Birth_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anos`)
};

const fr_fr2_profile_editors_birth_years = /** @type {(inputs: Profile_Editors_Birth_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ans`)
};

const de_de2_profile_editors_birth_years = /** @type {(inputs: Profile_Editors_Birth_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahre alt`)
};

const it_it2_profile_editors_birth_years = /** @type {(inputs: Profile_Editors_Birth_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anni`)
};

/**
* | output |
* | --- |
* | "years old" |
*
* @param {Profile_Editors_Birth_YearsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_birth_years = /** @type {((inputs?: Profile_Editors_Birth_YearsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Birth_YearsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_birth_years(inputs)
	if (locale === "es-419") return es_419_profile_editors_birth_years(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_birth_years(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_birth_years(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_birth_years(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_birth_years(inputs)
	return en_us2_profile_editors_birth_years(inputs)
});
export { profile_editors_birth_years as "profile-editors.birth_years" }